import { createFileRoute } from "@tanstack/react-router";

import { DocumentTitle } from "@/components";
import { CreateSalesPage } from "@/modules/user";
import { requireAuthAndPermission } from "@/utils";

export const Route = createFileRoute("/users/sales/create")({
  beforeLoad: requireAuthAndPermission,
  component: () => (
    <>
      <DocumentTitle
        title="Create Sales"
        description="Add a new sales team member to your organization."
      />
      <CreateSalesPage />
    </>
  )
});
